// src/constants/theme.js
export const THEME = {
    primary: '#1e3a8a',      // Dark Navy Blue (Login buttons, Titles)
    secondary: '#3b82f6',    // Bright Blue (Sidebar Active, Add Buttons)
    sidebarBg: '#0f172a',    // Dark Sidebar Background
    bodyBg: '#f8fafc',       // Light Gray Page Background
    white: '#ffffff',
    textMain: '#0f172a',
    textMuted: '#64748b',
    success: '#10b981',      // Green (Salary, Status)
    danger: '#ef4444',       // Red (Delete, Logout)
    warning: '#f59e0b',      // Orange (Password)
    border: '#e2e8f0',
    footerCompany: 'United Motors',
    footerTagline: 'Professional ERP Solution',
    footerVersion: 'v2.0.1',
    systemStatus: 'Active',
    year:2025
};